import * as React from 'react';

export const Close = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="-2 -2 16 16" {...props}>
    <path
      fill="currentColor"
      d="M7.06 5.999l4.772 4.773-1.06 1.06L5.999 7.06l-4.773 4.773-1.061-1.06 4.773-4.773L.165 1.226 1.225.165 6 4.938 10.772.165l1.06 1.06z"
    />
  </svg>
);
